import "./WidgetCheckList.css"
import { useEffect, useState } from "react";
import SrvButton from "../../../global/SrvButton";
import { Form, Modal } from "react-bootstrap";
import SrvButtonLink from "../../../global/SrvButtonLink";
import { useSelector } from "react-redux";
import BlockName from "../BlockName";
import WidgetCheckListItem from "./WidgetCheckListItem";
import immutabilityUpdate from 'immutability-helper'
import WidgetCheckListItemEdit from "./WidgetCheckListItemEdit";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../../util/ErrorAdd";

function WidgetCheckList({ idTask, idWidget, number, idObject, idTab, editMode, onlyRead, name, nameChange, showTracker, showTrackerChange, widgetUpdateHandler, requiredCompleted, requiredCompletedChange, added }) {
    /*
    idObject:
    ID	Name
    1	Задача
    2	Регулярная задача
    3	Доска
    4	Проект
    5	Пользователь
    6   Регулярная задача. Трекер

    //added - true при событии добавления виджета
    */

    const stateTask = useSelector((state) => state.taskList);//Задачи
    const stateTaskR = useSelector((state) => state.taskRlist);//Регулярные задачи.
    const stateTaskRTracker = useSelector((state) => state.taskRTrackerList);//Регулярные задачи. Трекер
    const stateBoardTask = useSelector((state) => state.boardTaskList);//Доски

    //Формат передаваемой dataCheckList: { id: null, number: 1, text: null, completed: false }
    /*status - 0-Загружено из БД; 1-Новая запись; 2-Обновить; 3-Удалить*/
    const [data, setData] = useState([]);
    const [edit, setEdit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [log, setLog] = useState(null);
    const [logCard, setLogCard] = useState(null);

    //Преобразовываем список в нужный формат
    useEffect(() => {
        setLog(null);

        /*
            public long ID { get; set; }
            public long ID_Item { get; set; }
            public int Widget_Number { get; set; }
            public string Name { get; set; }
            public bool Completed { get; set; }
            public int Order { get; set; }
        */

        //{ id: null, number: 1, name: null, status: 0, completed:false }
        if (idTask != null) {
            if (idObject === 1) {
                const data_ = stateTask.listCheckList.filter(a => a.ID_Item === idTask & a.id_tab === idTab & a.Widget_Number === number).map((item, index) => {
                    return { id: item.ID, name: item.Name, completed: item.Completed, order: item.Order, status: 0, num: index }
                })
                setData(data_.sort((a, b) => a.order - b.order));
            }
            else if (idObject === 2) {
                const data_ = stateTaskR.listCheckList.filter(a => a.ID_Item === idTask & a.id_tab === idTab & a.Widget_Number === number).map((item, index) => {
                    return { id: item.ID, name: item.Name, completed: item.Completed, order: item.Order, status: 0, num: index }
                })
                setData(data_.sort((a, b) => a.order - b.order));
            }
            else if (idObject === 6) {
                const data_ = stateTaskRTracker.listCheckList.filter(a => a.ID_TaskR_Tracker === idTask & a.id_tab === idTab & a.Widget_Number === number).map((item, index) => {
                    return { id: item.ID, name: item.Name, completed: item.Completed, order: item.Order, status: 0, num: index }
                })

                setData(data_.sort((a, b) => a.order - b.order));
            }
            else if (idObject === 3) {
                const data_ = stateBoardTask.listCheckList.filter(a => a.ID_Item === idTask & a.Widget_Number === number).map((item, index) => {
                    return { id: item.ID, name: item.Name, completed: item.Completed, order: item.Order, status: 0, num: index }
                })

                if (data_.length === 0) {
                    setData([{ id: null, name: null, completed: false, order: 0, status: 1, num: 0 }]);
                }
                else {
                    setData(data_.sort((a, b) => a.order - b.order));
                }
            }
        }
    }, [idTask, stateTask.listCheckList, stateTaskR.listCheckList, stateTaskRTracker.listCheckList, stateBoardTask.listCheckList]);

    useEffect(() => {
        if (added !== null & added !== undefined) {
            //Ограничение на добавление виджета определенного номера. Иначе открываются сразу все виджеты
            if (added.idWidget === idWidget & added.number === number) {
                setEdit(true);
            }
        }
    }, [added]);

    //Добавит элемент
    function addHandler() {
        //let order = data.sort((a, b) => b.order - a.order)[0].order + 1;
        //let num = data.sort((a, b) => b.num - a.num)[0].num + 1;
        const order = data.length;
        const num = data.length;

        setData([...data, { id: null, name: null, completed: false, order: order, status: 1, num: num }]);
    }
    //Удалит элемент
    function removeHandler(num) {
        const new_data = data.map((item) => {
            if (item.num == num) {
                return {
                    ...item,
                    status: 3
                }
            }
            else {
                return item
            }
        })
        setData(new_data)
        //  setData(data.filter(a=>a.number !== number))

    }
    //Изменет текст элемента
    function changeTextHandler(text, num) {
        const new_data = data.map((item) => {
            if (item.num == num) {
                //Если строка меняется из бд, то ставим флаг на изменение строки  
                if (item.status == 0) {
                    return {
                        ...item,
                        name: text, status: 2
                    }
                }
                else {
                    return {
                        ...item,
                        name: text
                    }
                }
            }
            else {
                return item
            }
        })
        setData(new_data)
    }
    //Сохранит изменения
    function saveHandler() {

        setLog(null);
        setLoading(true);
        if (idTask === null) {
            setLog('Сначала добавьте название задачи!');
        }
        else {
            const data_add = {
                ID_Item: idTask, Widget_Number: number, Items: data.filter(a => a.status === 1 & a.name !== undefined & a.name !== null).map((item) => {
                    return { Name: item.name, Order: item.order }
                })
            }
            const data_update = {
                ID_Item: idTask, Widget_Number: number, Items: data.filter(a => a.status === 2 & a.name !== undefined & a.name !== null).map((item) => {
                    return { ID: item.id, Name: item.name }
                })
            }
            const data_remove = {
                ID_Item: idTask, Widget_Number: number, Items: data.filter(a => a.status === 3 & a.id !== null).map((item) => {
                    return { ID: item.id }
                })
            }
            const data_order = {
                ID_Item: idTask, Widget_Number: number, Items: data.filter(a => a.id !== undefined & a.id !== null).map((item) => {
                    return { ID: item.id, Order: item.order }
                })
            }

            if (idObject === 1) {
                axios.post('/api_tracker/task/widgetChecklistAdd', data_add)//Добавление
                    .then((res1) => {
                        if (res1.data.Status === 1) {
                            axios.post('/api_tracker/task/widgetChecklistUpdate', data_update)//Изменение
                                .then((res2) => {
                                    if (res2.data.Status === 1) {
                                        axios.post('/api_tracker/task/widgetChecklistRemove', data_remove)//Удаление
                                            .then((res3) => {
                                                if (res3.data.Status === 1) {
                                                    axios.post('/api_tracker/task/widgetChecklistOrderChange', data_order)//Сортировка
                                                        .then((res) => {
                                                            if (res3.data.Status === 1) {
                                                                setEdit(false);
                                                            }
                                                            else {
                                                                setLog(res3.data.Error);
                                                                setLoading(false);
                                                            }
                                                        })
                                                        .catch((err) => {
                                                            setLog('Неизвестная ошибка!');
                                                            setLoading(false);
                                                            ErrorAdd(err, window.location.href);
                                                        });
                                                }
                                                else {
                                                    setLog(res3.data.Error);
                                                    setLoading(false);
                                                }
                                            })
                                            .catch((err) => {
                                                setLog('Неизвестная ошибка!');
                                                setLoading(false);
                                                ErrorAdd(err, window.location.href);
                                            });
                                    }
                                    else {
                                        setLog(res2.data.Error);
                                        setLoading(false);
                                    }
                                })
                                .catch((err) => {
                                    setLog('Неизвестная ошибка!');
                                    setLoading(false);
                                    ErrorAdd(err, window.location.href);
                                });
                        }
                        else {
                            setLog(res1.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
            if (idObject === 2) {
                axios.post('/api_tracker/taskR/widgetChecklistAdd', data_add)//Добавление
                    .then((res1) => {
                        if (res1.data.Status === 1) {
                            axios.post('/api_tracker/taskR/widgetChecklistUpdate', data_update)//Изменение
                                .then((res2) => {
                                    if (res2.data.Status === 1) {
                                        axios.post('/api_tracker/taskR/widgetChecklistRemove', data_remove)//Удаление
                                            .then((res3) => {
                                                if (res3.data.Status === 1) {
                                                    axios.post('/api_tracker/taskR/widgetChecklistOrderChange', data_order)//Сортировка
                                                        .then((res) => {
                                                            if (res3.data.Status === 1) {
                                                                setEdit(false);
                                                            }
                                                            else {
                                                                setLog(res3.data.Error);
                                                                setLoading(false);
                                                            }
                                                        })
                                                        .catch((err) => {
                                                            setLog('Неизвестная ошибка!');
                                                            setLoading(false);
                                                            ErrorAdd(err, window.location.href);
                                                        });
                                                }
                                                else {
                                                    setLog(res3.data.Error);
                                                    setLoading(false);
                                                }
                                            })
                                            .catch((err) => {
                                                setLog('Неизвестная ошибка!');
                                                setLoading(false);
                                                ErrorAdd(err, window.location.href);
                                            });
                                    }
                                    else {
                                        setLog(res2.data.Error);
                                        setLoading(false);
                                    }
                                })
                                .catch((err) => {
                                    setLog('Неизвестная ошибка!');
                                    setLoading(false);
                                    ErrorAdd(err, window.location.href);
                                });
                        }
                        else {
                            setLog(res1.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
            if (idObject === 3) {
                axios.post('/api_tracker/board/taskWidgetChecklistAdd', data_add)//Добавление
                    .then((res1) => {
                        if (res1.data.Status === 1) {
                            axios.post('/api_tracker/board/taskWidgetChecklistUpdate', data_update)//Изменение
                                .then((res2) => {
                                    if (res2.data.Status === 1) {
                                        axios.post('/api_tracker/board/taskWidgetChecklistRemove', data_remove)//Удаление
                                            .then((res3) => {
                                                if (res3.data.Status === 1) {
                                                    axios.post('/api_tracker/board/taskWidgetChecklistOrderChange', data_order)//Сортировка
                                                        .then((res) => {
                                                            if (res3.data.Status === 1) {
                                                                setEdit(false);
                                                            }
                                                            else {
                                                                setLog(res3.data.Error);
                                                                setLoading(false);
                                                            }
                                                        })
                                                        .catch((err) => {
                                                            setLog('Неизвестная ошибка!');
                                                            setLoading(false);
                                                            ErrorAdd(err, window.location.href);
                                                        });
                                                }
                                                else {
                                                    setLog(res3.data.Error);
                                                    setLoading(false);
                                                }
                                            })
                                            .catch((err) => {
                                                setLog('Неизвестная ошибка!');
                                                setLoading(false);
                                                ErrorAdd(err, window.location.href);
                                            });
                                    }
                                    else {
                                        setLog(res2.data.Error);
                                        setLoading(false);
                                    }
                                })
                                .catch((err) => {
                                    setLog('Неизвестная ошибка!');
                                    setLoading(false);
                                    ErrorAdd(err, window.location.href);
                                });
                        }
                        else {
                            setLog(res1.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }

            //Обновляем настройки виджета
            widgetUpdateHandler();
        }
    }
    //Изменение вкл/выкл чек листа
    function checkHandler(id, val) {
        if (idObject === 1) {
            /*
                public long ID_Checklist { get; set; }
                public long ID_TaskR_Tracker { get; set; }
                            public bool Completed { get; set; }      
            */

            axios.post('/api_tracker/task/widgetChecklistComplete', { ID_Checklist: id, ID_Task: idTask, Completed: val })
                .then((res) => {
                    if (res.data.Status === 1) {

                    }
                    else {
                        setLogCard(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLogCard('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });

        }
        if (idObject === 6) {
            /*
                public long ID_Checklist { get; set; }
                public long ID_TaskR_Tracker { get; set; }
                            public bool Completed { get; set; }      
            */

            axios.post('/api_tracker/taskR/widgetTrackerChecklistComplete', { ID_Checklist: id, ID_TaskR_Tracker: idTask, Completed: val })
                .then((res) => {
                    if (res.data.Status === 1) {

                    }
                    else {
                        setLogCard(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLogCard('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        if (idObject === 3) {
            axios.post('/api_tracker/board/taskWidgetChecklistComplete', { ID: id, Completed: val })
                .then((res) => {
                    if (res.data.Status === 1) {

                    }
                    else {
                        setLogCard(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLogCard('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }
    //Изменение сортировки
    function moveFile({ dragIndex, hoverIndex }) {
        const list_new = immutabilityUpdate(data, {
            $splice: [
                [dragIndex, 1],
                [hoverIndex, 0, data[dragIndex]],
            ],
        })
        const list_new_order = list_new.map((item, index) => {
            return { ...item, order: index };
        });

        setData(list_new_order)
    }


    return (
        <>
            {data.filter(a => a.id !== null).length === 0 && (
                onlyRead === false && (
                    <div className="text-center">
                        <SrvButton typeBtn='add' size='lg' textBtn="Добавить чек-лист" onClick={() => setEdit(true)} />
                    </div>
                )
            )}
            {edit === true && (
                <Modal key={idWidget + '_' + number} show={edit} onHide={() => setEdit(false)} >
                    <Modal.Body>
                        <div className="modal_close" onClick={() => setEdit(false)}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="modal_title text-center">Чек-лист</div>
                        <BlockName name={name} setName={nameChange} updateHandler={widgetUpdateHandler} />
                        {data.filter(a => a.status != 3).map((item, index) => (
                            <WidgetCheckListItemEdit key={item.num} index={index} order={item.order} num={item.num} moveFile={moveFile} model={item} number={number} removeHandler={removeHandler} changeTextHandler={changeTextHandler} />
                        ))}
                        <div className="mt-15" style={{ textAlign: "left" }}>
                            <SrvButtonLink typeBtn="add" onClick={() => addHandler()} disabled={loading} />
                        </div>

                        {idObject === 2 && (
                            <div className="mt-15">
                                <Form.Check
                                    type="switch"
                                    id="show_tracker_switch"
                                    label="Отображать в «Текущих задачах?»"
                                    defaultChecked={showTracker}
                                    onChange={(e) => showTrackerChange(e.target.checked)}
                                />
                            </div>
                        )}

                        <div className="mt-15">
                            <Form.Check
                                type="switch"
                                id="required_completed_switch"
                                label="Обязательно к выполнению"
                                defaultChecked={requiredCompleted}
                                onChange={(e) => requiredCompletedChange(e.target.checked)}
                            />
                        </div>

                        {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                        <div className="mt-15" style={{ textAlign: "center" }}>
                            <SrvButton typeBtn="save" size='lg' onClick={() => saveHandler()} disabled={loading} />
                        </div>
                    </Modal.Body>
                </Modal>
            )}
            {data.filter(a => a.id !== null).length > 0 && (
                <div className="card_widget_body">
                    {editMode === false && (
                        onlyRead !== true && (
                            <div className="card_widget_btn_edit">
                                <SrvButtonLink typeBtn="edit" textBtn="" onClick={() => setEdit(true)} />
                            </div>
                        )
                    )}
                    {data.filter(a => a.id !== null).sort((a, b) => a.order - b.order).map((item) => (
                        <WidgetCheckListItem key={item.id + '_' + item.completed} id={item.id} name={item.name} completed={item.completed} checkHandler={checkHandler} />
                    ))}
                    {logCard !== null && <div className="form_error text-center mt-15">{logCard}</div>}
                </div>
            )}
        </>
    )
}

export default WidgetCheckList;